<template>
  <v-container fluid
    class="pa-0 ma-0">
    <v-row justify="center"
      class="ma-0">
      <v-col cols="12"
        class="pa-0">
        <v-dialog v-model="dialog"
          v-if="dialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition">
          <v-card class="split-dialog-card">
            <div class="split-dialog-container">
              <v-card-actions class="pa-0 ma-0">
                <v-container fluid
                  class="pa-0 ma-0">
                  <v-row class="ma-0 tables-row">
                    <v-col cols="6"
                      class="pa-2 table-column-left">
                      <div class="table-wrapper glass-table-wrapper">
                        <div class="table-header-section">
                          <h2 class="table-title gradient-text">{{ selectedTable.name }}</h2>
                          <div class="table-total">{{ leftTotalFormatted }}</div>
                        </div>
                        <v-data-table :height="tableHeight"
                          fixed-header
                          :headers="headersLeft"
                          :items="sourceTable.items"
                          :items-per-page="-1"
                          hide-default-footer
                          class="split-table">
                                  <template #[`item.name`]="{ item }">
                                    <div class="item-name-text">{{ item.name }}</div>
                                  </template>
                                  <template #[`item.formattedUnitPrice`]="{ item }">
                                    {{ new Intl.NumberFormat("hr-HR", {
                                      style: "currency",
                                      currency: currency,
                                    }).format(item.prices[currency].price / 100) }}
                                  </template>
                                  <template #[`item.formattedTotal`]="{ item }">
                                    {{ new Intl.NumberFormat("hr-HR", {
                                      style: "currency",
                                      currency: currency,
                                    }).format((item.prices[currency].price / 100) * item.quantity) }}
                                  </template>
                                  <template #[`header.controls`]="props">
                                    <div class="header-controls-wrapper">
                                      <v-btn v-if="sourceTable.items.length > 0"
                                        icon
                                        x-large
                                        color="red"
                                        @click="
                                          onRowBtnClick(
                                            props.item,
                                            'pushEverythingRight'
                                          )
                                          ">
                                        <v-icon dark
                                          x-large>mdi-chevron-triple-right</v-icon>
                                      </v-btn>
                                    </div>
                                  </template>
                                  <template #[`item.quantity`]="{ item }">
                                    <div class="quantity-display">{{ item.quantity }}</div>
                                  </template>
                                  <template #[`item.controls`]="props">
                                    <div class="control-buttons-wrapper">
                                      <v-btn icon
                                        x-large
                                        color="red"
                                        @click="
                                          onRowBtnClick(
                                            props.item,
                                            'pushRight'
                                          )
                                          ">
                                        <v-icon dark
                                          x-large>mdi-chevron-right</v-icon>
                                      </v-btn>
                                      <v-btn icon
                                        x-large
                                        :disabled="!props.item ||
                                          props.item.type === 'menu-product'
                                          "
                                        color="red"
                                        @click="
                                          onRowBtnClick(
                                            props.item,
                                            'pushAllRight'
                                          )
                                          ">
                                        <v-icon dark
                                          x-large>mdi-chevron-double-right</v-icon>
                                      </v-btn>
                                    </div>
                                  </template>
                        </v-data-table>
                      </div>
                    </v-col>

                    <v-col cols="6"
                      class="pa-2 table-column-right">
                      <div class="table-wrapper glass-table-wrapper">
                        <div class="table-header-section">
                          <h2 class="table-title gradient-text">{{ $t("$vuetify.tables.selectedItems") }}</h2>
                          <div class="table-total">{{ rightTotalFormatted }}</div>
                        </div>
                        <v-data-table :height="tableHeight"
                          fixed-header
                          :headers="headersRight"
                          :items="destinationTable.items"
                          :items-per-page="-1"
                          hide-default-footer
                          class="split-table">
                                  <template #[`item.name`]="{ item }">
                                    <div class="item-name-text">{{ item.name }}</div>
                                  </template>
                                  <template #[`item.formattedUnitPrice`]="{ item }">
                                    {{ new Intl.NumberFormat("hr-HR", {
                                      style: "currency",
                                      currency: currency,
                                    }).format(item.prices[currency].price / 100) }}
                                  </template>
                                  <template #[`item.formattedTotal`]="{ item }">
                                    {{ new Intl.NumberFormat("hr-HR", {
                                      style: "currency",
                                      currency: currency,
                                    }).format((item.prices[currency].price / 100) * item.quantity) }}
                                  </template>
                                  <template #[`header.controls`]="props">
                                    <div class="header-controls-wrapper">
                                      <v-btn v-if="
                                        destinationTable.items.length > 0
                                      "
                                        icon
                                        x-large
                                        color="red"
                                        @click="
                                          onRowBtnClick(
                                            props.item,
                                            'pushEverythingLeft'
                                          )
                                          ">
                                        <v-icon dark
                                          x-large>mdi-chevron-triple-left</v-icon>
                                      </v-btn>
                                    </div>
                                  </template>
                                  <template #[`item.quantity`]="{ item }">
                                    <div class="quantity-display">{{ item.quantity }}</div>
                                  </template>
                                  <template #[`item.controls`]="props">
                                    <div class="control-buttons-wrapper">
                                      <v-btn icon
                                        x-large
                                        color="red"
                                        @click="
                                          onRowBtnClick(
                                            props.item,
                                            'pushAllLeft'
                                          )
                                          ">
                                        <v-icon dark
                                          x-large>mdi-chevron-double-left</v-icon>
                                      </v-btn>
                                      <v-btn icon
                                        x-large
                                        color="red"
                                        @click="
                                          onRowBtnClick(
                                            props.item,
                                            'pushLeft'
                                          )
                                          ">
                                        <v-icon dark
                                          x-large>mdi-chevron-left</v-icon>
                                      </v-btn>
                                    </div>
                                  </template>
                        </v-data-table>
                      </div>
                    </v-col>
                  </v-row>

                  <!-- Action Buttons -->
                  <v-row class="ma-0 action-buttons-row">
                    <v-col cols="12"
                      class="d-flex justify-center align-center pa-4">
                      <v-btn class="glass-action-btn glass-split-btn"
                        :disabled="buttonsDisabled"
                        :loading="isProcessingTransfer"
                        large
                        @click="save('newTable')">
                        <v-icon left>mdi-table-split-cell</v-icon>
                        {{ $t("$vuetify.tables.splitTable") }}
                      </v-btn>

                      <v-btn class="glass-action-btn glass-transfer-btn"
                        :disabled="buttonsDisabled"
                        :loading="isProcessingTransfer"
                        large
                        @click="save('existingTable')">
                        <v-icon left>mdi-transfer</v-icon>
                        Prebaci na drugi stol
                      </v-btn>

                      <v-btn class="glass-action-btn glass-cancel-btn"
                        :disabled="isProcessingTransfer"
                        large
                        @click="close">
                        <v-icon left>mdi-close</v-icon>
                        {{ $t("$vuetify.cancel") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-actions>
            </div>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <select-table-2-dialog ref="selectTableDialog"
      :availableTables="availableTables"
      @addItemsToTable="onAddItemsToTable"></select-table-2-dialog>
  </v-container>
</template>

<script>
import { clone } from '@/plugins/utils'
import SelectTable2Dialog from '@/modules/cash-register/components/dialogs/SelectTable2Dialog'
import Table from '@/model/Table'
import EventBus from '@/plugins/event-bus'
import state from '@/state'
export default {
  components: {
    SelectTable2Dialog
  },
  data () {
    return {
      dialog: false,
      isProcessingTransfer: false, // Zaštita od duplih transfera
      currency: 'EUR',
      tableHeight: '',
      useFloorPlanForTransfer: false, // Track if floor plan should be used
      headersLeft: [
        { text: 'Naziv', value: 'name', sortable: false, width: '40%' },
        { text: 'Kol', value: 'quantity', sortable: false, align: 'center', width: '10%' },
        { text: 'Cijena', value: 'formattedUnitPrice', sortable: false, align: 'end', width: '15%' },
        { text: 'Ukupno', value: 'formattedTotal', sortable: false, align: 'end', width: '15%' },
        { text: '', value: 'controls', sortable: false, width: '20%' }
      ],
      headersRight: [],
      sourceTable: {},
      destinationTable: {},
      paymentMenu: [
        { text: this.$t('$vuetify.paymentMethods.cash'), type: 'G', icon: 'mdi-cash' },
        { text: this.$t('$vuetify.paymentMethods.card'), type: 'K', icon: 'mdi-card' },
        { text: this.$t('$vuetify.paymentMethods.virman'), type: 'V', icon: 'mdi-card' }
      ],
      leftTotal: 0,
      rightTotal: 0
    }
  },
  computed: {
    buttonsDisabled () {
      return this.destinationTable?.items?.length === 0 || this.isProcessingTransfer
    },
    leftTotalFormatted () {
      return new Intl.NumberFormat('hr-HR', { style: 'currency', currency: this.currency }).format(this.leftTotal)
    },
    rightTotalFormatted () {
      return new Intl.NumberFormat('hr-HR', { style: 'currency', currency: this.currency }).format(this.rightTotal)
    }
  },
  props: {
    selectedTable: {
      type: Object,
      default: () => { }
    },
    selectedTables: {
      type: Array,
      default: () => []
    },
    availableTables: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    open () {
      this.destinationTable = new Table()
      this.headersRight = clone(this.headersLeft.slice(0, 4))
      this.headersRight.unshift({ text: '', value: 'controls', sortable: false, align: 'end' })

      this.tableHeight = 'calc(100vh - 200px)'
      this.sourceTable = clone(this.selectedTable)
      this.sourceTable.items = this.sourceTable.items.sort((a, b) => a.name.localeCompare(b.name))
      this.calculateTotals()
      this.checkIfFloorPlanEnabled()
      this.dialog = true
    },

    checkIfFloorPlanEnabled () {
      try {
        const cashRegisterId = state.getCashRegister().id
        const useTablesKey = `use_tables_${cashRegisterId}`
        const tableModeKey = `table_mode_${cashRegisterId}`

        const useTables = localStorage.getItem(useTablesKey) === 'true'
        const tableMode = localStorage.getItem(tableModeKey)

        this.useFloorPlanForTransfer = useTables && tableMode === 'floor'
      } catch (err) {
        console.error('Error checking floor plan setting:', err)
        this.useFloorPlanForTransfer = false
      }
    },

    checkFloorPlanAndOpen () {
      if (this.useFloorPlanForTransfer) {
        // Open floor plan in transfer mode
        EventBus.$emit('open-floor-plan-for-transfer', {
          sourceTable: this.sourceTable,
          destinationTable: this.destinationTable
        })
      } else {
        // Fall back to SelectTable2Dialog (existing behavior)
        this.$refs.selectTableDialog.open(this.sourceTable, this.destinationTable)
      }
    },

    close () {
      // Spriječi zatvaranje ako je transfer u tijeku
      if (this.isProcessingTransfer) {
        console.warn('⚠️ Ne mogu zatvoriti dialog dok je transfer u tijeku')
        return
      }
      this.isProcessingTransfer = false
      this.dialog = false
    },

    onRowBtnClick (item, action) {
      if (action === 'pushEverythingRight') {
        this.transferEverything({ leftTable: this.sourceTable, rightTable: this.destinationTable }, action)
      } else if (action === 'pushEverythingLeft') {
        this.transferEverything({ leftTable: this.destinationTable, rightTable: this.sourceTable }, action)
      } else {
        this.transferItem(item, action)
      }
    },

    onAddItemsToTable (sourceTable, destinationTable, itemsToTransfer) {
      // Postavi flag lokalno i emituj event ka parent-u
      this.isProcessingTransfer = true
      // Emituj event da parent zna da treba prikazati svoj overlay
      EventBus.$emit('table-transfer-starting')
      this.$emit('addItemsToTable', sourceTable, destinationTable, itemsToTransfer)
      // NE zatvaraj dialog odmah - čekaj da transfer završi
      // Dialog će se zatvoriti u onTransferCompleted() kada parent emituje 'table-transfer-completed'
    },

    save (action) {
      switch (action) {
        case 'newTable':
          if (this.isProcessingTransfer) return
          this.isProcessingTransfer = true
          // Emituj event da parent zna da treba prikazati svoj overlay
          EventBus.$emit('table-transfer-starting')
          console.log('SplitReceipt: Emitovao table-transfer-starting event za split table')
          this.$emit('createNewTable', this.sourceTable, this.destinationTable)
          // NE zatvaraj dialog odmah - čekaj da se novi stol kreira
          // Dialog će se zatvoriti kada parent završi operaciju
          break
        case 'existingTable':
          if (this.isProcessingTransfer) return
          // NE postavljaj flag ovdje - postavit će se kada korisnik odabere stol
          this.checkFloorPlanAndOpen()
          break
        default:
          break
      }
    },

    transferEverything (tables, action) {
      const transferAction = action === 'pushEverythingRight' ? 'pushAllRight' : 'pushAllLeft'
      for (let i = tables.leftTable.items.length - 1; i >= 0; i--) {
        const item = tables.leftTable.items[i]
        this.transferItem(item, transferAction)
      }
    },

    transferItem (item, action) {
      let tables = {}
      const all = action === 'pushAllRight' || action === 'pushAllLeft'
      if (action === 'pushRight' || action === 'pushAllRight') {
        tables = { leftTable: this.sourceTable, rightTable: this.destinationTable }
      } else if (action === 'pushLeft' || action === 'pushAllLeft') {
        tables = { leftTable: this.destinationTable, rightTable: this.sourceTable }
      }
      this.updateDestinationItemQuantity(item, all, tables)
      this.updateOriginItemQuantity(item, all, tables)
    },

    recalcItemTotal (item) {
      const unitPrice = (item.discountedUnitPrice != null) ? item.discountedUnitPrice : item.prices[this.currency].price
      item.total = unitPrice * item.quantity
    },

    updateDestinationItemQuantity (item, all, tables) {
      const otherItemIdx = tables.rightTable.items.findIndex(i => i.id === item.id)
      if (all) {
        if (otherItemIdx === -1) {
          const otherItem = clone(item)
          tables.rightTable.items.push(otherItem)
        } else {
          tables.rightTable.items[otherItemIdx].quantity += item.quantity
          this.recalcItemTotal(tables.rightTable.items[otherItemIdx])
        }
      } else {
        if (otherItemIdx < 0) {
          const otherItem = clone(item)
          otherItem.quantity = 1
          this.recalcItemTotal(otherItem)
          tables.rightTable.items.push(otherItem)
        } else {
          tables.rightTable.items[otherItemIdx].quantity += 1
          this.recalcItemTotal(tables.rightTable.items[otherItemIdx])
        }
      }
      tables.rightTable.items = tables.rightTable.items.sort((a, b) => a.name.localeCompare(b.name))
      this.calculateTotals()
    },

    updateOriginItemQuantity (item, all, tables) {
      const itemIdx = tables.leftTable.items.findIndex(i => i.id === item.id)
      if (itemIdx < 0) return
      if (all) {
        tables.leftTable.items.splice(itemIdx, 1)
      } else {
        if (item.quantity > 1) {
          item.quantity -= 1
          this.recalcItemTotal(item)
        } else {
          tables.leftTable.items.splice(itemIdx, 1)
        }
      }
      tables.leftTable.items = tables.leftTable.items.sort((a, b) => a.name.localeCompare(b.name))
      this.calculateTotals()
    },

    calculateTotals () {
      this.leftTotal = 0
      this.sourceTable.items.forEach(item => {
        this.leftTotal += item.prices[this.currency].price / 100 * item.quantity
      })

      this.rightTotal = 0
      this.destinationTable.items.forEach(item => {
        this.rightTotal += item.prices[this.currency].price / 100 * item.quantity
      })
    },

    async onSelectTableForTransfer ({ selectedTableId }) {
      console.log('SplitReceipt: onSelectTableForTransfer primio event za stol:', selectedTableId)

      // ✅ Early return ako je transfer već u tijeku
      if (this.isProcessingTransfer) {
        console.warn('⚠️ Transfer već u tijeku, ignoriram dupli poziv')
        return
      }

      // Postavi flag - maska se prikazuje tek kada je stol odabran
      this.isProcessingTransfer = true
      console.log('SplitReceipt: Postavio isProcessingTransfer = true')

      // Emituj event da parent zna da treba prikazati svoj overlay
      EventBus.$emit('table-transfer-starting')
      console.log('SplitReceipt: Emitovao table-transfer-starting event ka parent-u')

      // Čekaj da se overlay sigurno renderira - povećan delay
      await this.$nextTick()
      await new Promise(resolve => setTimeout(resolve, 200))
      console.log('SplitReceipt: Overlay bi trebao biti vidljiv sada (nakon 200ms delay-a)')

      // Find the actual table object from availableTables
      const targetTable = this.availableTables.find(t => t.id === selectedTableId)
      console.log('SplitReceipt: Pronađen targetTable:', targetTable ? 'DA' : 'NE')

      if (targetTable) {

        // Replicate EXACT logic from SelectTable2Dialog.onCellClick
        // Just add items from destinationTable to targetTable
        // Let the parent (PanelPaymentSelection) handle removing from source
        this.destinationTable.items.forEach((item) => {
          if (targetTable.items) {
            const existingItem = targetTable.items.find((i) => i.id === item.id)

            if (existingItem) {
              // Item already exists - update quantity and total
              existingItem.quantity += item.quantity
              // Calculate total safely (handle undefined discountedUnitPrice)
              const unitPrice = item.discountedUnitPrice || (item.prices && item.prices[this.currency] ? item.prices[this.currency].price / 100 : 0)
              existingItem.total += unitPrice * item.quantity
            } else {
              // New item - clone to avoid reference issues
              const clonedItem = clone(item)
              targetTable.items.push(clonedItem)
            }
          } else {
            // First item in empty table - clone to avoid reference issues
            targetTable.items = [clone(item)]
          }
        })

        // IMPORTANT: Clone targetTable to avoid reference issues
        // Parent will reset items array, which would clear our targetTable.items
        const clonedTargetTable = clone(targetTable)
        const itemsToTransfer = clone(this.destinationTable.items)

        // Emit to parent - parent will handle source table cleanup
        // NE zatvaraj dialog odmah - čekaj da transfer završi
        console.log('SplitReceipt: Emitiram addItemsToTable event ka parent-u')
        this.$emit('addItemsToTable', this.sourceTable, clonedTargetTable, itemsToTransfer)
        console.log('SplitReceipt: NE zatvaram dialog - čekam table-transfer-completed event')
        // Dialog će se zatvoriti u onTransferCompleted() kada parent emituje 'table-transfer-completed'
      } else {
        // Handle error: table not found
        console.error('[SplitReceipt] Selected table not found:', selectedTableId)

        // PRVO zatvori overlay i dijaloge
        this.isProcessingTransfer = false
        EventBus.$emit('table-transfer-completed')

        // Čekaj da se overlay zatvori
        await this.$nextTick()
        await new Promise(resolve => setTimeout(resolve, 200))

        // TEK ONDA prikaži grešku
        this.$parent.$parent.$parent.showMsgBox({
          title: 'Greška',
          text: 'Odabrani stol nije pronađen. Molimo osvježite stranicu i pokušajte ponovo.'
        })

        // Zatvori dialog
        this.dialog = false
      }
    },

    onTransferCompleted () {
      console.log('SplitReceipt: Primio table-transfer-completed event')
      // Reset flag when transfer is completed
      this.isProcessingTransfer = false
      console.log('SplitReceipt: Resetirao isProcessingTransfer na false')
      // Zatvori dialog direktno (ne kroz close() jer ima provjeru)
      this.dialog = false
      console.log('SplitReceipt: Zatvorio dialog')
    }
  },

  created () {
    // Listen for table selection from floor plan in transfer mode
    EventBus.$on('select-table-for-transfer', this.onSelectTableForTransfer)
    // Listen for transfer completion
    EventBus.$on('table-transfer-completed', this.onTransferCompleted)
  },

  beforeDestroy () {
    // Clean up EventBus listeners
    EventBus.$off('select-table-for-transfer', this.onSelectTableForTransfer)
    EventBus.$off('table-transfer-completed', this.onTransferCompleted)
  }
}
</script>
<style scoped>
/* Main Dialog Container */
.split-dialog-card {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.03) 0%,
    rgba(57, 137, 201, 0.02) 50%,
    rgba(97, 84, 164, 0.03) 100%) !important;
  height: 100vh !important;
}

.split-dialog-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Tables Row - Full Height */
.tables-row {
  flex: 1;
  height: calc(100vh - 100px);
  overflow: hidden;
}

.table-column-left,
.table-column-right {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Glass Table Wrapper */
.glass-table-wrapper {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.15) !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Table Header Section */
.table-header-section {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.5) 0%,
    rgba(57, 137, 201, 0.45) 50%,
    rgba(97, 84, 164, 0.5) 100%) !important;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid rgba(0, 179, 190, 0.3);
}

.table-title {
  font-size: 28px !important;
  font-weight: 700 !important;
  margin: 0 !important;
}

.gradient-text {
  background: linear-gradient(135deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0.95) 50%,
    rgba(255, 255, 255, 1) 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
  letter-spacing: 0.5px !important;
  display: inline-block !important;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.table-total {
  font-size: 32px !important;
  font-weight: 700 !important;
  color: white !important;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

/* Data Table Styling */
.split-table {
  flex: 1;
  background: transparent !important;
  overflow: hidden;
}

.split-table >>> .v-data-table__wrapper {
  height: 100% !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  -webkit-overflow-scrolling: touch !important;
  touch-action: pan-y !important;
  overscroll-behavior: contain !important;
}

.split-table >>> table {
  background: transparent !important;
  table-layout: fixed !important;
  width: 100% !important;
}

.split-table >>> th,
.split-table >>> td {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.split-table >>> thead {
  background: rgba(57, 137, 201, 0.08) !important;
}

.split-table >>> thead th {
  font-size: 1.1rem !important;
  font-weight: 700 !important;
  color: #3989C9 !important;
  padding: 16px 12px !important;
  border-bottom: 2px solid rgba(57, 137, 201, 0.2) !important;
  height: 64px !important;
  min-height: 64px !important;
  max-height: 64px !important;
}

/* Header Controls Wrapper - Fixed Height */
.header-controls-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px !important;
  min-height: 32px !important;
  width: 100%;
}

.split-table >>> tbody tr {
  height: 70px !important;
  transition: background 0.2s ease !important;
}

.split-table >>> tbody tr:hover {
  background: rgba(57, 137, 201, 0.05) !important;
}

.split-table >>> tbody td {
  font-size: 1.1rem !important;
  padding: 12px !important;
  border-bottom: 1px solid rgba(0, 179, 190, 0.1) !important;
}

/* Item Name - Uppercase */
.item-name-text {
  text-transform: uppercase !important;
  font-weight: 600 !important;
  letter-spacing: 0.3px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
}

/* Quantity Display - Read Only */
.quantity-display {
  font-size: 1.2rem !important;
  font-weight: 700 !important;
  color: #3989C9 !important;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

/* Control Buttons Wrapper */
.control-buttons-wrapper {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-end !important;
  gap: 8px !important;
  flex-wrap: nowrap !important;
  white-space: nowrap !important;
  padding: 0 8px !important;
}

.split-table >>> .v-data-table__wrapper tbody td {
  white-space: nowrap !important;
}

.split-table >>> tbody td:last-child {
  width: 20% !important;
  min-width: 140px !important;
}

/* Action Buttons Row */
.action-buttons-row {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(20px) !important;
  border-top: 2px solid rgba(0, 179, 190, 0.2);
  box-shadow: 0 -4px 20px rgba(0, 179, 190, 0.1);
  min-height: 100px;
}

/* Glass Action Buttons */
.glass-action-btn {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(10px) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(57, 137, 201, 0.3) !important;
  box-shadow: 0 4px 16px rgba(0, 179, 190, 0.2) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 1.1rem !important;
  letter-spacing: 0.3px !important;
  padding: 0 32px !important;
  height: 56px !important;
  min-width: 200px !important;
  margin: 0 12px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.glass-split-btn {
  color: #3989C9 !important;
}

.glass-split-btn:hover:not(:disabled) {
  background: linear-gradient(135deg,
    rgba(57, 137, 201, 0.95) 0%,
    rgba(33, 97, 140, 0.9) 100%) !important;
  color: white !important;
  border-color: rgba(57, 137, 201, 0.6) !important;
  box-shadow: 0 8px 24px rgba(57, 137, 201, 0.4) !important;
  transform: translateY(-2px) scale(1.02);
}

.glass-transfer-btn {
  color: #00B3BE !important;
}

.glass-transfer-btn:hover:not(:disabled) {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.95) 0%,
    rgba(0, 150, 160, 0.9) 100%) !important;
  color: white !important;
  border-color: rgba(0, 179, 190, 0.6) !important;
  box-shadow: 0 8px 24px rgba(0, 179, 190, 0.4) !important;
  transform: translateY(-2px) scale(1.02);
}

.glass-cancel-btn {
  color: #F44336 !important;
}

.glass-cancel-btn:hover {
  background: linear-gradient(135deg,
    rgba(244, 67, 54, 0.95) 0%,
    rgba(211, 47, 47, 0.9) 100%) !important;
  color: white !important;
  border-color: rgba(244, 67, 54, 0.6) !important;
  box-shadow: 0 8px 24px rgba(244, 67, 54, 0.4) !important;
  transform: translateY(-2px) scale(1.02);
}

.glass-action-btn:disabled {
  opacity: 0.5 !important;
  background: rgba(200, 200, 200, 0.3) !important;
  color: rgba(100, 100, 100, 0.5) !important;
  cursor: not-allowed !important;
}

.glass-action-btn .v-icon {
  font-size: 24px !important;
}

/* Chevron Control Buttons - Glass Style */
::v-deep .v-btn--icon {
  background: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(57, 137, 201, 0.2) !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.15) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

::v-deep .v-btn--icon:hover {
  background: rgba(57, 137, 201, 0.1) !important;
  border-color: rgba(57, 137, 201, 0.4) !important;
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.25) !important;
  transform: scale(1.1);
}

::v-deep .v-btn--icon .v-icon {
  color: #3989C9 !important;
}

/* Scrollbar Styling */
.split-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

.split-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
  background: rgba(57, 137, 201, 0.05);
  border-radius: 10px;
}

.split-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.5) 0%,
    rgba(57, 137, 201, 0.5) 100%);
  border-radius: 10px;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.split-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.8) 0%,
    rgba(57, 137, 201, 0.8) 100%);
}
</style>
